import { render, staticRenderFns } from "./SettingsPanelAreaHeader.vue?vue&type=template&id=f397f100"
import script from "./SettingsPanelAreaHeader.vue?vue&type=script&lang=js"
export * from "./SettingsPanelAreaHeader.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanelAreaHeader.vue?vue&type=style&index=0&id=f397f100&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports